/** J12: a ring around the auto button showing today's auto budget left (shared autoBudget.ts, J2). */
import { AUTO_BUDGET, type World } from '@nine/shared';

const NS = 'http://www.w3.org/2000/svg';
const R = 27;
const C = 2 * Math.PI * R;

/** Wraps nothing: the ring is a sibling SVG laid over `host` (a positioned box holding the button). Returns the per-frame sync. */
export function attachAutoRing(host: HTMLElement, world: World): () => void {
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'auto-ring');
  svg.setAttribute('viewBox', '0 0 64 64');
  const mk = (cls: string) => {
    const c = document.createElementNS(NS, 'circle');
    c.setAttribute('class', cls);
    c.setAttribute('cx', '32');
    c.setAttribute('cy', '32');
    c.setAttribute('r', String(R));
    svg.append(c);
    return c;
  };
  mk('ar-bg');
  const fg = mk('ar-fg');
  fg.setAttribute('stroke-dasharray', String(C));
  fg.setAttribute('transform', 'rotate(-90 32 32)');
  host.append(svg);
  let last = -1;
  return () => {
    const secs = world.progress.autoBudget?.secs ?? AUTO_BUDGET.dailySeconds;
    const f = Math.min(1, Math.max(0, secs / AUTO_BUDGET.dailySeconds));
    const q = Math.round(f * 200);
    if (q === last) return;
    last = q;
    fg.setAttribute('stroke-dashoffset', String(C * (1 - f)));
    svg.classList.toggle('low', f < 0.15);
    host.title = `เวลาออโต้เหลือวันนี้ ${Math.floor(secs / 3600)} ชม. ${Math.floor((secs % 3600) / 60)} นาที`;
  };
}
